const OPTION_CATEGORY = {
    OPTIONS: 1,
    ACCESSORIES: 2,
};

export default OPTION_CATEGORY;
